import React, { useState } from "react";
import "./comingSoon.scss";
import Navbar from "../../components/Navbar/navbar";

const ComingSoon = () => {

  const [email, setEmail] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    if (email.trim()) {
      console.log("Email submitted:", email);
      setEmail("");
      alert("Thanks for subscribing!");
    }
  };
  return (
    <div>
        <Navbar />
        <div className="background">
        <div className="overlay"></div>
        <div className="content">
            <h1>🚧 Coming Soon</h1>
            <p>
            Construction machines like transit mixers, boom pumps, and concrete
            pumps are running on the road. There are RMC plants, buildings being
            built, and roads under construction.
            </p>
            <p className="tagline">
            We're building something amazing for you. 
            Add your email address below to stay up-to-date with announcements and our launch proposals.
            </p>

            <form className="content__form" onSubmit={handleSubmit}>
            <input
                type="email"
                placeholder="Email Address"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
            />
            <button type="submit">Go</button>
            </form>
        </div>
        </div>
    </div>
  );
};

export default ComingSoon;
